import { BaseUniDriver } from '@wix/wix-ui-test-utils/base-driver';
import { baseUniDriverFactory } from '../../testkitUtils/unidriver';
import { UniDriver } from '@wix/wix-ui-test-utils/unidriver';
import {
  iconToggleDriverFactory,
  IconToggleDriver,
} from '../IconToggle/IconToggle.driver';

export interface LikeButtonDriver extends BaseUniDriver, IconToggleDriver {}

export const likeButtonDriverFactory = (
  base: UniDriver,
  body: UniDriver,
): LikeButtonDriver => {
  const iconToggleDriver = iconToggleDriverFactory(base, body);

  return {
    ...baseUniDriverFactory(base),
    ...iconToggleDriver,
  };
};
